document.addEventListener('DOMContentLoaded', function () {
    // ── Buttons fade-in ──
    var buttons = document.querySelector('.buttons');
    if (buttons) {
      setTimeout(function () {
        buttons.style.opacity = '1';
      }, 300);
    }

    // ── Text rotator ──
    var items = document.querySelectorAll('.text-rotator span');
    var index = 0;

    if (items.length) {
      (function showNext() {
        var current = items[index];
        current.classList.add('active');

        setTimeout(function () {
          current.classList.remove('active');
          current.classList.add('exit');

          setTimeout(function () {
            current.classList.remove('exit');
            index = (index + 1) % items.length;
            showNext();
          }, 600);
        }, 3000);
      })();
    }

    // ── Scrolling Banner Web Component ──
    if (!customElements.get('scrolling-banner')) {
      class ScrollingBanner extends HTMLElement {
        constructor() {
          super();
          this.init();
        }

        init() {
          var self = this;
          var marquees = this.querySelectorAll('.marquee');

          marquees.forEach(function (marquee) {
            var original = marquee.querySelector('.marquee-content');
            if (!original) return;

            var itemWidth = original.scrollWidth;
            var viewportWidth = marquee.offsetWidth;

            var needed = Math.ceil((viewportWidth * 3) / itemWidth) + 1;
            var current = marquee.querySelectorAll('.marquee-content').length;

            for (var i = current; i < needed; i++) {
              var clone = original.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              marquee.appendChild(clone);
            }

            // Make first visible copy's images eager, rest stay lazy
            var firstContent = marquee.querySelector('.marquee-content');
            if (firstContent) {
              firstContent.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
                img.loading = 'eager';
              });
            }
          });

          // Start animation after fonts are ready
          document.fonts.ready.then(function () {
            marquees.forEach(function (m) {
              m.classList.add('marquee--animate');
            });
          });
        }
      }
      window.customElements.define('scrolling-banner', ScrollingBanner);
    }

    // ── Rotating Product Web Component ──
    // Replaces autoplay <video> with WebP frame sequence.
    // Static cache shares preloaded frames across marquee clones of the same product.
    if (!customElements.get('rotating-product')) {
      class RotatingProduct extends HTMLElement {
        constructor() {
          super();
          this.frames = [];
          this.currentFrame = 0;
          this.totalFrames = 0;
          this.fps = parseInt(this.dataset.fps || 4);
          this.isVisible = false;
          this.timeout = null;
        }

        connectedCallback() {
          var urlsAttr = this.dataset.frameUrls;
          if (!urlsAttr) return;

          var img = this.querySelector('img');
          if (!img) return;

          var urls;
          try {
            urls = JSON.parse(urlsAttr);
          } catch (e) {
            console.warn('rotating-product: JSON parse failed', e);
            return;
          }
          if (!Array.isArray(urls)) return;
          this.totalFrames = urls.length;
          if (this.totalFrames < 2) return;

          var key = this.dataset.product || 'default';

          if (RotatingProduct.frameCache.has(key)) {
            this.frames = RotatingProduct.frameCache.get(key);
          } else {
            this.frames = [];
            RotatingProduct.frameCache.set(key, this.frames);
            this.loadFrames(urls);
          }

          this.setupObserver();
        }

        loadFrames(urls) {
          var self = this;

          // Frame 1 staat al in <img src>; cache het Image object voor symmetrie.
          var first = new Image();
          first.src = urls[0];
          this.frames.push(first);

          // Frames 2-N via requestIdleCallback om burst te voorkomen op slow networks.
          var loadIdx = 1;
          var loadNext = function () {
            if (loadIdx >= urls.length) return;
            var frame = new Image();
            frame.src = urls[loadIdx];
            self.frames.push(frame);
            loadIdx++;

            if (window.requestIdleCallback) {
              requestIdleCallback(loadNext, { timeout: 100 });
            } else {
              setTimeout(loadNext, 16);
            }
          };

          if (window.requestIdleCallback) {
            requestIdleCallback(loadNext);
          } else {
            setTimeout(loadNext, 100);
          }
        }

        setupObserver() {
          var self = this;
          this.observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              self.isVisible = entry.isIntersecting;
              if (self.isVisible) {
                self.startAnimation();
              } else {
                self.stopAnimation();
              }
            });
          }, { rootMargin: '50px' });
          this.observer.observe(this);
        }

        startAnimation() {
          if (this.timeout || this.totalFrames < 2) return;

          var self = this;
          var img = this.querySelector('img');
          if (!img) return;

          var tick = function () {
            if (!self.isVisible) {
              self.timeout = null;
              return;
            }
            self.currentFrame = (self.currentFrame + 1) % self.totalFrames;
            var frame = self.frames[self.currentFrame];
            if (frame && frame.complete) {
              img.src = frame.src;
            }
            self.timeout = setTimeout(tick, 1000 / self.fps);
          };
          this.timeout = setTimeout(tick, 1000 / this.fps);
        }

        stopAnimation() {
          if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
          }
        }

        disconnectedCallback() {
          this.stopAnimation();
          if (this.observer) {
            this.observer.disconnect();
          }
        }
      }
      RotatingProduct.frameCache = new Map();
      window.customElements.define('rotating-product', RotatingProduct);
    }
  });
